module.exports = __webpack_public_path__ + "static/media/img_12.3e95c34d.png";